import { getTenant } from "../../handlers/getTenant";

/**
 * Dominios de los tenants de Banamex. Es el espejo de `BANAMEX_SCHEMAS` en el
 * backend (casemanager/views/banamex.py): al dar de alta un tenant hay que
 * agregarlo en los dos lados.
 */
export const BANAMEX_DOMAINS = [
  'banamexstaging.linea-etica.com',  // staging
  // Instalacion de Mexico (api-mx)
  'dev.lineaeticabanamex.com',       // SIT
  'uat.lineaeticabanamex.com',       // UAT
  'lineaeticabanamex.com',           // produccion
];

/**
 * @returns {boolean} true si el tenant actual es de Banamex
 */
export const isBanamexTenant = () => BANAMEX_DOMAINS.includes(getTenant());
